import { WorkflowStepCode } from '@exam-management/graphql';
import type { QSetReviewWorkflowStepCode } from '@exam-management/task-management';

export enum ReviewResultVariant {
  HIDDEN = 'HIDDEN',
  EDITABLE = 'EDITABLE',
  READONLY = 'READONLY',
}

const assigneeVariant: Record<QSetReviewWorkflowStepCode, ReviewResultVariant> = {
  [WorkflowStepCode.ReviewQsetTodo]: ReviewResultVariant.READONLY,
  [WorkflowStepCode.ReviewQsetInReview]: ReviewResultVariant.EDITABLE,
  [WorkflowStepCode.ReviewQsetReviewed]: ReviewResultVariant.READONLY,
  [WorkflowStepCode.ReviewQsetDone]: ReviewResultVariant.READONLY,
};

const otherVariant: Record<QSetReviewWorkflowStepCode, ReviewResultVariant> = {
  [WorkflowStepCode.ReviewQsetTodo]: ReviewResultVariant.HIDDEN,
  [WorkflowStepCode.ReviewQsetInReview]: ReviewResultVariant.HIDDEN,
  [WorkflowStepCode.ReviewQsetReviewed]: ReviewResultVariant.READONLY,
  [WorkflowStepCode.ReviewQsetDone]: ReviewResultVariant.READONLY,
};

export default function getReviewResultVariant(
  roles: { isOwner: boolean; isAssigner: boolean; isAssignee: boolean },
  workflowStepCode: QSetReviewWorkflowStepCode,
): ReviewResultVariant | null {
  if (roles.isAssignee) {
    // REMARK: assignee takes precedence even when also assigner
    return assigneeVariant[workflowStepCode];
  }

  if (roles.isAssigner || roles.isOwner) {
    return otherVariant[workflowStepCode];
  }

  return null;
}
